"use client";

import { FC, useMemo } from "react";

import { MODALS } from "@Shared/config";
import { useModalState } from "@Shared/store";
import { AnimationFadeInBlur, AnimationFadeInGradientMask, Text } from "@Shared/ui";

import { Container, ContainerProps } from "./Container";

export type ModalInfoProps = ContainerProps;

export const ModalInfo: FC<ModalInfoProps> = () => {
    const { activeModals, isOpen, getData } = useModalState(["activeModals", "isOpen", "getData"]);
    const isModalOpen = useMemo(() => isOpen(MODALS.info), [activeModals, isOpen]);
    const modalData = useMemo(() => getData(MODALS.info), [activeModals, getData]);

    return (
        <Container>
            {typeof modalData?.title === "string" && (
                <AnimationFadeInGradientMask once={false} done={!isModalOpen}>
                    <Text as="h2" variant="h2" weight={600}>
                        {modalData.title}
                    </Text>
                </AnimationFadeInGradientMask>
            )}

            {typeof modalData?.text === "string" && (
                <AnimationFadeInBlur delay={0.5} once={false} done={!isModalOpen}>
                    <Text as="p" color="text-light-gray">
                        {modalData.text}
                    </Text>
                </AnimationFadeInBlur>
            )}
        </Container>
    );
};
